import type { TemplateResourceListResponseV2Api } from '@ingenico/api-sdk-device-management-private-v2';

export function mapApplicationVersionTemplatesById(
  data: TemplateResourceListResponseV2Api,
): TemplateResourceListResponseV2Api {
  return {
    ...data,
  };
}
